
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "copyPipeline",
      resolverType: "mutation",
      routePath: "/copyPipeline",
      httpMethod: "POST",
    });
  